import styled from '@emotion/styled'
import { Button } from 'antd'

export const ManageRoot = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`

export const ContentCard = styled.div<{ padding?: number }>(
  ({ padding = 24 }) => `
  margin: 0 auto;
  width: 100%;
  max-width: 640px;
  padding: ${padding}px 24px;
  background-color: #fff;
  border-radius: 6px;
`
)

export const PageDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  margin-bottom: 24px;
`

export const DeleteButton = styled(Button)`
  color: #a40000;
  background: transparent;
  border: 1px solid #a40000;

  &:disabled,
  &:hover,
  &:focus,
  &:active {
    color: #a40000;
    background: transparent;
    border: 1px solid #a40000;
  }

  &:disabled {
    opacity: 0.4;

    &:hover,
    &:focus,
    &:active {
      color: #a40000;
      background: transparent;
      border: 1px solid #a40000;
    }
  }
`

export const RemoveButton = styled(Button)`
  display: flex;
  align-items: center;

  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize !important;
  color: #a40000;
  border: none;

  &:hover,
  &:focus,
  &:active {
    color: #a40000;
    background: transparent;
    border: none;
  }
`

export const Card = styled.div<{
  isLoading?: boolean
  gap?: number
  marginBottom?: number
  borderColor?: string
}>(
  ({ isLoading, gap = 16, marginBottom = 24, borderColor = '#a4a4b3' }) => `
  position: relative;

  display: flex;
  flex-direction: column;
  gap: ${gap}px;

  padding: 12px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  margin-bottom: ${marginBottom}px;

  ${
    isLoading &&
    `
      .ant-select-selector {
        position: relative;
        z-index: 0;

        &::after{
          content:'';
          position: absolute;
          left:0;
          top:0;
          border-radius: 5px;
          display: inline-flex;
          visibility:visible;
          width: 100%;
          height: 100%;
          z-index: 3;
          background-size: 200% 100%;
          background-image: linear-gradient(90deg, #f8f8f8 0, #ededed 10%, #f8f8f8 15%, #f8f8f8 55%, #ededed 65%, #f8f8f8 70%);
          animation: shimmer 3s linear infinite
        }
      }

      @keyframes shimmer {
        0% {
          background-position: 100%;
        }
        100% {
          background-position: -100%;
        }
      }
    `
  }
`
)

export const FormLabel = styled.div(
  ({ marginBottom = 8 }: { marginBottom?: number }) => `
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: ${marginBottom}px;
`
)

export const FormItemTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #4a4a68;
  line-height: 1;
`

export const FormItemDescription = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #77778e;
  line-height: 1.2;
`

export const StepRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const StepGrid = styled.div<{ hasSidebar?: boolean }>(
  ({ hasSidebar }) => `
  display: grid;
  grid-template-columns: ${
    hasSidebar ? 'minmax(580px, 1fr) minmax(320px, 1fr)' : 'minmax(580px, 1fr)'
  };
  gap: 24px;
  align-items: start;
  max-width: ${hasSidebar ? '920px' : '658px'};
  margin: 0 auto;
`
)

export const ContentPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ActionCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  > button {
    width: min-content;
  }
`

export const PrimaryButton = styled(Button)`
  position: relative;
  background-color: #4a4a68;
  color: #ffffff;
  border-color: #4a4a68;
  justify-content: center;
  align-items: center;

  // antd wraps multi-child button contents in its own <span>; that wrapper
  // must be a flex row for an absolutely-positioned spinner span to center
  // inside it (see ButtonLabel/ButtonSpinner in partner-specific styles).
  & > span {
    display: flex;
    align-items: center;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #4a4a68;
    color: #ffffff;
    border-color: #4a4a68;
  }

  &:disabled {
    opacity: 0.4;

    &:hover,
    &:focus,
    &:active {
      background-color: #4a4a68;
      color: #ffffff;
      border-color: #4a4a68;
    }
  }
`

export const OutlineButton = styled(Button)`
  background: #ffffff;
  color: #4a4a68;
  border: 1px solid #4a4a68;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus,
  &:active {
    background: #ffffff;
    color: #4a4a68;
    border: 1px solid #4a4a68;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #4a4a68;
`
